import getUTMTags from '../helpers/UTM-tags';

const UTMTags = {
  data: () => ({
    UTMTags: '',
  }),
  mounted() {
    this.fetchUTMTags();
  },
  methods: {
    fetchUTMTags() {
      const tags = getUTMTags();
      if (tags === 'loading') {
        setTimeout(() => {
          this.fetchUTMTags();
        }, 300);
        return;
      }
      this.UTMTags = (tags) ? `?${tags}` : '';
    },
  },
};

export default UTMTags;
